import { WorkerImportController } from "../../../controllers";
import { DataImportComponentBase } from "./DataImportComponentBase";

/**
 * User interface for worker mass loading.
 * @example
 * ```html
 * <salaxy-worker-import></salaxy-worker-import>
 * ```
 */
export class WorkerImport extends DataImportComponentBase {

    /** Uses the WorkerImportController */
    public controller = WorkerImportController;

}
